module.exports = __webpack_public_path__ + "24e1a2eefc57ea9296fb99fd343ddb8a.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/trailer_preview-420.webp.png
// module id = 559
// module chunks = 0